// @ts-nocheck

import React from 'react';
import { Switch, Route } from 'react-router-dom';
import styled, { css } from 'styled-components';

import GlobalStyleGrid from '../../modules/grids/components/GlobalStyleGrid';
import GridsBasketViewContainer from '../../modules/grids/containers/basket/GridsBasketViewContainer';
import { Licences } from '../../types/common';
import { RoutePatterns } from '../../types/routes';
import Sticky from '../Sticky';

const RightColumnWrapper = styled.div`
  ${({ $isGridHistory }) =>
    $isGridHistory
      ? css`
          display: none;
        `
      : css`
          display: block;
        `}

  width: 350px;
  margin-left: 10px;

  ${({ theme }) => css`
    @media screen and (min-width: ${theme.breakpoints.lg}px) and (max-width: ${theme.breakpoints.xl - 1}px) {
      margin-left: 53px;
    }

    @media screen and (min-width: ${theme.breakpoints.xl}px) {
      margin-left: 120px;
    }
  `}
`;

type DesktopGridsLayoutRightColumnProps = {
  isGridHistory: boolean;
  licence: string;
};

/**
 * Display the right column for the grids section
 *
 * @param  {boolean} isGridHistory Check if we are on grid history (the history detail is excluded)
 * @param  {string} licence        The current licence
 * @return {ReactNode}             A styled component with all the necessary routes
 */
const DesktopGridsLayoutRightColumn = ({ isGridHistory, licence }: DesktopGridsLayoutRightColumnProps) => {
  return (
    <RightColumnWrapper $isGridHistory={isGridHistory}>
      <Sticky disabled={licence === Licences.DE}>
        <GlobalStyleGrid>
          <Switch>
            <Route path={RoutePatterns.GRID_SHARE} exact>
              <GridsBasketViewContainer />
            </Route>
            <Route path={RoutePatterns.GRID_PUBLIC} exact>
              <GridsBasketViewContainer />
            </Route>
            <Route path={RoutePatterns.GRID_HISTORY_DETAIL} exact>
              <GridsBasketViewContainer />
            </Route>
            <Route path={RoutePatterns.POOL} exact>
              <GridsBasketViewContainer />
            </Route>
          </Switch>
        </GlobalStyleGrid>
      </Sticky>
    </RightColumnWrapper>
  );
};

export default DesktopGridsLayoutRightColumn;
